import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';

const sections = [
  {
    title: '1. 個人情報の収集について',
    content: `当社は、お問い合わせ・サービスのご提供・その他業務上の必要性に応じて、お客様の個人情報（氏名、会社名、メールアドレス、電話番号、その他ご提供いただいた情報）を収集することがあります。個人情報の収集に際しては、利用目的を明示した上で、適法かつ公正な手段により行います。`,
  },
  {
    title: '2. 個人情報の利用目的',
    content: `収集した個人情報は、以下の目的のために利用します。\n・ご相談・お問い合わせへの対応\n・サービスの提供・履行\n・サービスに関するご案内・情報提供\n・業務上の連絡・通知\n・法令に基づく対応\n\n上記以外の目的で個人情報を利用する場合は、事前にお客様の同意を得るものとします。`,
  },
  {
    title: '3. 個人情報の第三者提供',
    content: `当社は、以下の場合を除き、お客様の個人情報を第三者に提供しません。\n・お客様本人の同意がある場合\n・法令に基づく場合\n・人の生命、身体または財産の保護のために必要がある場合\n・公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合\n・国の機関等が法令の定める事務を遂行することに対して協力する必要がある場合`,
  },
  {
    title: '4. 個人情報の管理',
    content: `当社は、個人情報の正確性及び安全性を確保するために、セキュリティ対策を実施しています。不正アクセス、紛失、破損、改ざん、漏洩などのリスクに対して、適切な安全管理措置を講じます。また、個人情報を取り扱う従業員に対して、適切な監督を行います。`,
  },
  {
    title: '5. 個人情報の開示・訂正・削除',
    content: `お客様は、当社が保有するご自身の個人情報について、開示・訂正・削除・利用停止を請求する権利を有します。ご請求の際は、本ページ記載の連絡先までお問い合わせください。本人確認の上、合理的な期間内に対応いたします。`,
  },
  {
    title: '6. Cookieの使用について',
    content: `当社のウェブサイトでは、サービス品質の向上やアクセス解析のためにCookieを使用することがあります。Cookieの使用を希望されない場合は、ブラウザの設定により無効にすることが可能ですが、一部サービスが正常に機能しない場合があります。`,
  },
  {
    title: '7. プライバシーポリシーの変更',
    content: `当社は、法令の変更その他の事由により、本ポリシーを変更することがあります。変更後のポリシーは、当ウェブサイトへの掲載をもって公表します。重要な変更がある場合は、当ウェブサイト上でお知らせします。`,
  },
  {
    title: '8. お問い合わせ',
    content: `個人情報の取り扱いに関するお問い合わせは、以下までご連絡ください。\n\n【個人情報取扱責任者】\n株式会社ＡＬＡ\n代表取締役　山崎翔太郎\n東京都豊島区南長崎２丁目１２番１０号レーベンシュロス２０２号\nTEL：050-8896-2530\nEmail：banking@ala-info.com`,
  },
];

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <section className="w-full bg-[#F5F2ED] pt-32 pb-12 px-6 md:px-16">
        <p className="text-xs tracking-[0.3em] text-[#C8501A] uppercase mb-3">Legal</p>
        <h1 className="text-3xl md:text-4xl font-black text-[#0A0E1A]">プライバシーポリシー</h1>
        <p className="text-sm text-[#6B6560] mt-3">
          株式会社ＡＬＡ（以下「当社」）は、お客様の個人情報の保護を重要な責務と考え、以下のとおりプライバシーポリシーを定めます。
        </p>
        <p className="text-xs text-[#9C9490] mt-2">制定日：2019年6月5日 ／ 最終更新日：2026年4月21日</p>
      </section>

      {/* Content */}
      <section className="w-full px-6 md:px-16 py-12 max-w-4xl">
        <div className="space-y-8">
          {sections.map((s) => (
            <div key={s.title}>
              <h2 className="text-sm font-bold text-[#0A0E1A] mb-3 border-l-4 border-[#C8501A] pl-3">
                {s.title}
              </h2>
              <div className="text-sm text-[#6B6560] leading-relaxed whitespace-pre-line pl-3">
                {s.content}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-[#EEE9E3] flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-[#9C9490]">© 2019–2026 株式会社ＡＬＡ All Rights Reserved.</p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-[#0A0E1A] text-white text-xs font-medium rounded-full hover:bg-[#C8501A] transition-colors cursor-pointer whitespace-nowrap"
          >
            お問い合わせ <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
